import benefits from "../../../../src/content/treatments/clear-and-brilliant/clear-brilliant-1.jpg";
import * as React from 'react';
export default {
  benefits,
  React
};